<script>
	import {API,http_headers} from '../global.js'
	import Reserva from './reserva.svelte'
	

	export let data = {info:{IdCliente:''}}
	let idcliente = data.info.IdCliente || 0

	let page = 0
	let rpp = 5
	let update = false
	let loading = false


	$: refresh = async() => {
		let res = await fetch(`${API}/cliente-reservas/${idcliente}?u=${update}&p=${page}&rpp=${rpp}`)
		const ds = await res.json()
		return ds || []
	}

</script>

<div class="container-fluid mt-4 ">

	{#await refresh()}
		<p>Loading....</p>
		{:then ds}
			{#each ds.data as item, index}
				<Reserva reserva={item} />
			{:else}
				<p>No se encontraron reservas.</p>
			{/each}
		
	{/await}
	
</div>

